export default "__VITE_ASSET__D2g_MlTj__"